import { render, staticRenderFns } from "./Paso2SA.vue?vue&type=template&id=6d9d7307&"
import script from "./Paso2SA.vue?vue&type=script&lang=js&"
export * from "./Paso2SA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports